<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="districts"
        @select="selectTest"
        @select-all="selectAll">
      <div slot="toolbar">
        <el-button
            type="primary"
            @click="$refs.editDistrict.open(0)">
          新建
        </el-button>
        <el-button
            type="danger"
            @click="deleteIds">
          批量删除
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="区域编号">
            <el-input v-model.trim="filter.districtNO" clearable/>
          </vm-search>
          <vm-search label="区域名称">
            <el-input v-model.trim="filter.districtName" clearable/>
          </vm-search>
          <vm-search label="上级区域">
            <el-input v-model.trim="filter.parentName" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="55"/>
      <el-table-column prop="districtNO" align="center" label="区域编号"/>
      <el-table-column prop="districtName" align="center" label="区域名称"/>
      <el-table-column prop="parentName" align="center" label="上级区域"/>
      <el-table-column prop="note" align="center" label="备注"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="180px">
        <template slot-scope="scope">
          <el-button type="danger" @click="oneDelete(scope.row)">删除</el-button>
          <el-button type="primary" @click="$refs.editDistrict.open(scope.row.districtID)">编辑</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <district-edit ref="editDistrict" @save-success="getList(1)"/>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import DistrictEdit from "@/views/information/District/DistrictEdit";

  export default {
    name: "DistrictList",
    components: {DistrictEdit, VmTable, VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          districtNO: "",
          districtName: "",
          parentName: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      selectAll(selection) {
        this.idList = selection;
        console.log(selection);
      },
      //批量删除
      deleteIds() {
        if(this.idList.length) {
          let ids = [];
          for (let item of this.idList) {
            ids.push(item.districtID);
          }
          //console.log(ids);
          this.$http
            .delete("basic","districts/idList",ids).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
              this.idList = "";
            });
        }else{
          this.$message.error("请选择要删除的内容");
        }

      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic","districts",row.districtID).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
